import { useEffect, useRef, useState } from 'react';
import { getDeviceType } from '../../../Utils/helper';
import { fetchAvailableSizes } from '../../../datafetchers/maternityPage';
import ScrollWrapper from '../../ScrollWrapper/ScrollWrapper';
import ProductList from '../ProductList';
import SubCategoryBanner from '../SubCategoryBanner';
import { servedSectionEvent } from '../instrumentation';
import { SubCategorySection } from './styled';

export default function SubCategoryContainer(props) {
  const {
    data,
    scrollRef,
    activeElement,
    containerRef,
    showHeader,
    setShowSizePopup,
    setProductId,
    setActiveElement,
    setEventsData,
    wrapHeight,
    setWrapHeight,
    userType,
    setAddedToCart,
    categoryName,
  } = props;
  const oldScrollValue = useRef(0);
  const throttleTimeout = useRef(false);
  const [statusOfIds, setStatusOfIds] = useState();
  const chipsWrapOnScroll = () => {
    if (!throttleTimeout.current) {
      setTimeout(() => {
        let newValue = window.pageYOffset;
        if (oldScrollValue.current < newValue && newValue > 100) {
          setWrapHeight(0);
        } else if (oldScrollValue.current > newValue && newValue < 100) {
          setWrapHeight(130);
        }
        oldScrollValue.current = newValue;
        throttleTimeout.current = false;
      }, 100);
    }
    throttleTimeout.current = true;
  };

  const fetchStatusOfProducts = async (addToCart) => {
    const statuses = await fetchAvailableSizes(addToCart);
    if (statuses?.success) setStatusOfIds(statuses?.data);
  };

  useEffect(() => {
    window.addEventListener('scroll', chipsWrapOnScroll);
    const addToCart = [];
    data?.map((element) => {
      const ids = [];
      element?.items?.map((item) => {
        ids.push(item._id);
        if (item?.sizeVariants?.length === 0) {
          addToCart.push({ skuId: item._id });
        }
      });

      const url = window.location.pathname;
      const ids_trimmed = ids.toString().substring(0, 99);
      servedSectionEvent(
        element?.heading,
        element?._id,
        ids_trimmed,
        url.substring(0, 99),
      );
    });
    if (addToCart?.length) {
      fetchStatusOfProducts(addToCart);
    }
    return () => {
      window.removeEventListener('scroll', chipsWrapOnScroll);
    };
  }, []);

  useEffect(() => {
    if (Number(activeElement) > 4000) {
      const bodyRect = document.body.getBoundingClientRect();
      const value = scrollRef?.current?.getBoundingClientRect();
      const totalOffset = value?.top - bodyRect?.top;
      const isHeaderVisible = showHeader == '-56px' ? 58 : 120;
      if (value?.top !== undefined) {
        const extraScroll =
          getDeviceType() === 'desktop' ? 150 : isHeaderVisible;

        window?.scrollTo({
          top: totalOffset - extraScroll - wrapHeight,
          behavior: 'smooth',
        });
      }
    } else {
      setActiveElement((prev) => (prev + 100).toString());
    }
  }, [activeElement]);
  return (
    <div ref={containerRef}>
      {data?.map((element, index) => {
        let card_id = [];
        element?.items?.map((product) => {
          card_id.push(product?._id);
        });

        card_id = card_id.toString().slice(0, 99);
        const dataObj = {
          category: 'impression_section_in_myloshop',
          section_id: element?._id || element?.id,
          section_name: element?.heading || element?.itemName,
          shape: element?.itemType,
          deeplink_value: element?.deeplinkValue,
          card_ids: card_id,
        };
        return (
          <ScrollWrapper
            key={`subcategory_${index}`}
            data={dataObj}
            sectionId={element?._id}
          >
            <SubCategorySection
              id={element?._id}
              key={'section' + index}
              ref={activeElement === element?._id ? scrollRef : null}
            >
              <SubCategoryBanner
                heading={element?.heading}
                image={element?.sectionBgImage}
                bannerId={element?._id}
                index={index}
              />
              <ProductList
                type={element?.heading}
                setShowSizePopup={setShowSizePopup}
                items={element?.items}
                setProductId={setProductId}
                sectionId={element?._id}
                setEventsData={setEventsData}
                userType={userType}
                setAddedToCart={setAddedToCart}
                categoryName={categoryName}
                statusOfIds={statusOfIds}
                index={index}
              />
            </SubCategorySection>
          </ScrollWrapper>
        );
      })}
    </div>
  );
}
